const e=t=>{if(!!t){if(t?.data&&typeof t?.data=="object")return t.data;if(!("error"in t))return t}};var r=e;export{r as default};
